import React, { useContext, useEffect, useRef, useState } from "react";
import RadioButton from "../radio/RadioButton";
import Form from "antd/lib/form";
import DatePicker from "antd/lib/date-picker";
import TimePicker from "antd/lib/time-picker";
import notification from "antd/lib/notification";
import QalortButton from "../Button";
import clock from "../../assets/Clock.svg";
import SvgCalendar from "../../icons/SvgCalendar";
import BaseInput from "../BaseInput";
import BaseSelect from "../BaseSelect";
import {
  DAILY,
  MONTHLY,
  ONCE,
  WEEKLY,
  frequencyTypes,
} from "./cohorts.constants";
import dayjs from "dayjs";
import NewSessionModal from "./NewSessionModal";
import { AppContext } from "../../context";
import ScheduleTable from "./ScheduleTable";

export const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
function CreateStep2({ goToNext }) {
  let clearTimerRef = useRef();
  const { formFields, updateContext } = useContext(AppContext);
  const { frequency } = formFields;
  const [step2Form] = Form.useForm();
  const [pricing, setPricing] = useState(!formFields?.price ? "Free" : "Paid");
  const [visible, setVisible] = useState(false);
  // const [recurringForm] = Form.useForm();
  const [recurringSchedule, setRecurringSchedule] = useState(
    !!formFields?.frequency || null
  );
  const [schedules, setSchedules] = useState(formFields.schedules || []);
  const [newSchedule, setNewSchedule] = useState({});

  const clearDatesAndSchedule = () => {
    step2Form.setFieldValue("start_time", null);
    step2Form.setFieldValue("end_time", null);
    step2Form.setFieldValue("start_date", null);
    step2Form.setFieldValue("end_date", null);
    setNewSchedule({});
    setSchedules([]);
    updateContext({
      ...formFields,
      start_time: null,
      end_time: null,
      start_date: null,
      end_date: null,
      schedules: [],
    });
  };

  useEffect(() => {
    schedules.length &&
      updateContext({
        ...formFields,
        schedules,
      });
  }, [schedules]);

  useEffect(() => {
    let data = formFields;
    if (formFields.start_date) {
      data.start_date = dayjs(formFields.start_date);
    }
    if (data?.schedules?.length > 0) {
      data.start_time = dayjs("1/1/1 " + formFields.schedules[0]?.start_time);
      data.end_time = dayjs("1/1/1 " + formFields.schedules[0]?.end_time);
    }

    if (formFields.frequency === ONCE) {
      setRecurringSchedule(null);
      setNewSchedule({
        ...newSchedule,
        start_date: formFields.start_date.format("YYYY-MM-DD"),
      });
    }
    step2Form.setFieldsValue(data);
  }, [step2Form]);

  return (
    <>
      <Form
        form={step2Form}
        onFinish={(values) => {
          if (!pricing) {
            notification.error({
              message: "Please select a pricing option",
            });
            return;
          }
          if (recurringSchedule === undefined) {
            notification.error({
              message: "Please select a scheduling option",
            });
            return;
          }
          if (!formFields.end_date) {
            updateContext({ ...formFields, end_date: formFields.start_date });
          }

          if (recurringSchedule === null) {
            updateContext({ ...formFields, frequency: ONCE });
          }
          goToNext();
        }}
      >
        <div className="flex flex-col gap-6 mb-12">
          <div>
            <div className="py-[7px] px-3 w-full bg-light-tint mb-6">
              <p className="p-xs mb-0 font-medium text-dark">Pricing</p>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex gap-4">
                <RadioButton
                  testid="pricing_paid"
                  title="Paid"
                  className="flex-1"
                  value="Paid"
                  isChecked={pricing === "Paid"}
                  onChange={(e) => {
                    setPricing(e);
                  }}
                />
                <RadioButton
                  testid="pricing_free"
                  title="Free"
                  className="flex-1"
                  value="Free"
                  isChecked={pricing === "Free"}
                  onChange={(e) => {
                    setPricing(e);
                    updateContext({ ...formFields, price: 0 });
                  }}
                />
              </div>

              {pricing === "Paid" && (
                <div className="flex" data-testid="paid_input">
                  <div className="w-[150px]">
                    <BaseSelect
                      testid="paid_currency"
                      placeholder="USD"
                      name="currency"
                      options={[
                        // {
                        //   value: "NGN",
                        //   label: "NGN",
                        // },
                        {
                          value: "USD",
                          label: "USD",
                        },
                      ]}
                      disabled={true}
                      defaultValue={"USD"}
                      value={"USD"}
                      selectClassName="h-14"
                      onChange={(currency) =>
                        updateContext({ ...formFields, currency })
                      }
                    />
                  </div>
                  <div className="w-full">
                    <BaseInput
                      data-testid="paid_amount"
                      value={formFields.price ? formFields.price : null}
                      onChange={(e) =>
                        updateContext({
                          ...formFields,
                          price: Number(e.target.value),
                        })
                      }
                      placeholder="0.00"
                      type="number"
                      suffixClassName="right-4"
                      rules={[
                        { required: true, message: "Please input a price!" },
                      ]}
                    >
                      {/* <p className="mb-0 p-sm text-dark font-medium">rate/hr</p> */}
                    </BaseInput>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            <div className="py-[7px] px-3 w-full bg-light-tint mb-6">
              <p className="p-xs mb-0 font-medium text-dark">Schedule</p>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex gap-4">
                <RadioButton
                  testid="one_time"
                  title="One time"
                  className="flex-1"
                  value="One time"
                  isChecked={recurringSchedule === null}
                  onChange={() => {
                    setRecurringSchedule(null);
                    updateContext({
                      ...formFields,
                      frequency: ONCE,
                      schedules: [],
                    });
                    clearDatesAndSchedule();
                  }}
                />
                <RadioButton
                  testid="recurring"
                  title="Recurring"
                  className="flex-1"
                  value="Recurring"
                  isChecked={Boolean(recurringSchedule)}
                  onChange={() => {
                    setRecurringSchedule(true);
                    clearDatesAndSchedule();
                  }}
                  // onChange={createRecurringCohort}
                />
              </div>
              {/* {Boolean(recurringSchedule) && (
                <>
                  <div className="border py-[10.5px] px-4 border-neutral rounded-md flex items-center justify-between">
                    <div className="flex gap-3 items-center">
                      <img src={repeat} alt="" className="w-[18px] h-[18px]" />

                      <p className="mb-0 p-sm font-medium text-dark">
                        {recurringSchedule.repeat_every} time{" "}
                        {recurringSchedule.frequency}
                      </p>
                    </div>

                    <button className="pri font-medium">Edit</button>
                  </div>

                  <div className="border py-[10.5px] px-4 border-neutral rounded-md flex items-center justify-between">
                    <div className="flex gap-3 items-center">
                      <SvgCalendar className="w-[18px] h-[18px] text-light" />
                      <p className="mb-0 p-sm font-medium text-dark">
                        {recurringSchedule?.start_date?.format("L")}-
                        {recurringSchedule?.end_date?.format("L")}
                      </p>
                    </div>

                    <button className="pri font-medium">Edit</button>
                  </div>

                  <div className="border py-[10.5px] px-4 border-neutral rounded-md flex items-center justify-between">
                    <div className="flex gap-3 items-center">
                      <img src={clock} alt="" className="w-[18px] h-[18px]" />
                      <p className="mb-0 p-sm font-medium text-dark">
                        {recurringSchedule?.start_time?.format("LT")}-
                        {recurringSchedule?.end_time?.format("LT")}
                      </p>
                    </div>

                    <button className="pri font-medium">Edit</button>
                  </div>
                </>
              )} */}

              {recurringSchedule === null && (
                <div>
                  <div className="mt-4">
                    <div className="w-full">
                      <label className="text-main font-medium p-xs">Date</label>
                      <Form.Item
                        rules={[
                          { required: true, message: "Please select a date!" },
                        ]}
                        name="start_date"
                        valuePropName="start_date"
                        className="!mb-0"
                      >
                        <DatePicker
                          data-testid="date-picker"
                          dropdownClassName="date-picker-content"
                          // data-testid="start_date"
                          className="recurring-date"
                          id="date_input"
                          placeholder="DD/MM/YY"
                          suffixIcon={<SvgCalendar className="text-light" />}
                          style={{
                            borderRadius: "0.5rem",
                            border: "1px solid #eceef8",
                            fontSize: "0.9375rem",
                            backgroundColor: "#fff",
                            height: 56,
                            width: "100%",
                            color: "#30307d",
                          }}
                          disabledDate={(current) =>
                            current.isBefore(dayjs().format("YYYY-MM-DD"))
                          }
                          value={
                            newSchedule.start_date
                              ? dayjs(newSchedule.start_date)
                              : ""
                          }
                          onChange={(e) => {
                            updateContext({
                              ...formFields,
                              start_date: e.format("YYYY-MM-DD"),
                            });
                            setNewSchedule({
                              ...newSchedule,
                              start_date: e.format("YYYY-MM-DD"),
                            });
                            clearTimerRef.current = setTimeout(() => {
                              setSchedules([
                                {
                                  ...schedules[0],
                                  date: e.format("YYYY-MM-DD"),
                                },
                              ]);
                            }, 500);
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>

                  <div className="flex gap-4 mt-4">
                    <div className="w-full">
                      <label className="text-main font-medium p-xs">
                        Start Time
                      </label>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please select a start time!",
                          },
                        ]}
                        name="start_time"
                        className="!mb-0"
                      >
                        <TimePicker
                          data-testid="start_time"
                          className="recurring-date"
                          placeholder="8:00"
                          suffixIcon={<img src={clock} alt="" />}
                          use12Hours
                          minuteStep={30}
                          showSecond={false}
                          changeOnBlur={true}
                          popupClassName="one_time_start_time"
                          style={{
                            borderRadius: "0.5rem",
                            border: "1px solid #eceef8",
                            fontSize: "0.9375rem",
                            backgroundColor: "#fff",
                            height: 56,
                            width: "100%",
                            color: "#30307d",
                          }}
                          onChange={(e) => {
                            setSchedules([
                              {
                                ...schedules[0],
                                start_time: e.format("HH:mm"),
                              },
                            ]);
                          }}
                        />
                      </Form.Item>
                    </div>

                    <div className="w-full">
                      <label className="text-main font-medium p-xs">
                        End Time
                      </label>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please select an end time!",
                          },
                        ]}
                        name="end_time"
                        className="!mb-0"
                      >
                        <TimePicker
                          data-testid="end_time"
                          className="recurring-date"
                          placeholder="10:00"
                          suffixIcon={<img src={clock} alt="" />}
                          use12Hours
                          minuteStep={30}
                          showSecond={false}
                          changeOnBlur={true}
                          popupClassName="one_time_end_time"
                          style={{
                            borderRadius: "0.5rem",
                            border: "1px solid #eceef8",
                            fontSize: "0.9375rem",
                            backgroundColor: "#fff",
                            height: 56,
                            width: "100%",
                            color: "#30307d",
                          }}
                          onChange={(e) => {
                            setSchedules([
                              {
                                ...schedules[0],
                                end_time: e.format("HH:mm"),
                              },
                            ]);
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              )}

              {recurringSchedule === true && (
                <>
                  {/* // <Form onSubmitCapture={setFormSchedule} form={recurringForm}> */}
                  <div className="flex flex-col gap-5">
                    <div className="grid gap-4 grid-cols-2">
                      <div className="w-full">
                        <label className="text-main font-medium p-xs">
                          Start Date
                        </label>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select a date!",
                            },
                          ]}
                          name="start_date"
                          className="!mb-0"
                          valuePropName="start_date"
                        >
                          <DatePicker
                            data-testid="start_date"
                            className="recurring-date"
                            dropdownClassName="recurring-start-date"
                            id="date_input"
                            placeholder="DD/MM/YY"
                            suffixIcon={<SvgCalendar className="text-light" />}
                            disabledDate={(current) =>
                              current.isBefore(dayjs().format("YYYY-MM-DD"))
                            }
                            style={{
                              borderRadius: "0.5rem",
                              border: "1px solid #eceef8",
                              fontSize: "0.9375rem",
                              backgroundColor: "#fff",
                              height: 56,
                              width: "100%",
                              color: "#30307d",
                            }}
                            onChange={(e) =>
                              updateContext({
                                ...formFields,
                                start_date: e.format("YYYY-MM-DD"),
                              })
                            }
                            defaultValue={
                              formFields.start_date
                                ? dayjs(formFields.start_date)
                                : null
                            }
                          />
                        </Form.Item>
                      </div>
                      <div className="w-full">
                        <label className="text-main font-medium p-xs">
                          End Date
                        </label>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select an end date!",
                            },
                          ]}
                          name="end_date"
                          className="!mb-0"
                          valuePropName="end_date"
                        >
                          <DatePicker
                            data-testid="end_date"
                            className="recurring-date"
                            dropdownClassName="recurring-end-date"
                            id="date_input"
                            placeholder="DD/MM/YY"
                            suffixIcon={<SvgCalendar className="text-light" />}
                            disabledDate={(current) =>
                              current.isBefore(dayjs().format("YYYY-MM-DD"))
                            }
                            defaultValue={
                              formFields.start_date
                                ? dayjs(formFields.end_date)
                                : null
                            }
                            style={{
                              borderRadius: "0.5rem",
                              border: "1px solid #eceef8",
                              fontSize: "0.9375rem",
                              backgroundColor: "#fff",
                              height: 56,
                              width: "100%",
                              color: "#30307d",
                            }}
                            onChange={(e) => {
                              updateContext({
                                ...formFields,
                                end_date: e.format("YYYY-MM-DD"),
                              });
                            }}
                          />
                        </Form.Item>
                      </div>
                      <div className="w-full">
                        <BaseSelect
                          testid="frequency"
                          label="Add Frequency"
                          placeholder="eg. Weekly"
                          name="frequency"
                          options={frequencyTypes.map((type) => ({
                            value: type,
                            label: type,
                          }))}
                          selectClassName="h-14"
                          onChange={(frequency) => {
                            updateContext({
                              ...formFields,
                              frequency,
                              schedules: [],
                            });
                            // clearDatesAndSchedule();
                            setNewSchedule({});
                          }}
                          rules={[
                            {
                              required: true,
                              message: "Please select a frequency!",
                            },
                          ]}
                        />
                      </div>
                      {![DAILY, ONCE].includes(frequency) ? (
                        <div className="w-full">
                          <div
                            onClick={() => {
                              if ([WEEKLY, MONTHLY].includes(frequency)) {
                                setVisible(true);
                              } else {
                                notification.info({
                                  message:
                                    "Please select a frequency option first",
                                });
                              }
                            }}
                            className="!py-4 mt-6 w-full flex items-center justify-center text-sm px-4 mr-2 rounded-md border-pri bg-pri text-white"
                          >
                            Add new session
                          </div>
                        </div>
                      ) : (
                        <div className="w-full"></div>
                      )}
                    </div>
                    <div className="w-full">
                      {[DAILY, ONCE].includes(frequency) && (
                        <div className="flex gap-4">
                          <div className="w-full">
                            <label className="text-main font-medium p-xs">
                              Start Time
                            </label>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a start time!",
                                },
                              ]}
                              name="start_time"
                              className="!mb-0"
                            >
                              <TimePicker
                                // open
                                data-testid="start_time"
                                popupClassName="recurring_start_time"
                                className="recurring-date"
                                placeholder="e.g 8:00"
                                suffixIcon={<img src={clock} alt="" />}
                                use12Hours
                                minuteStep={30}
                                showSecond={false}
                                changeOnBlur={true}
                                style={{
                                  borderRadius: "0.5rem",
                                  border: "1px solid #eceef8",
                                  fontSize: "0.9375rem",
                                  backgroundColor: "#fff",
                                  height: 56,
                                  width: "100%",
                                  color: "#30307d",
                                }}
                                onChange={(e) => {
                                  setSchedules([
                                    {
                                      ...schedules[0],
                                      start_time: e.format("HH:mm"),
                                    },
                                  ]);
                                }}
                              />
                            </Form.Item>
                          </div>
                          <div className="w-full">
                            <label className="text-main font-medium p-xs">
                              End Time
                            </label>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: "Please select an end time!",
                                },
                              ]}
                              name="end_time"
                              className="!mb-0"
                            >
                              <TimePicker
                                data-testid="end_time"
                                popupClassName="recurring_end_time"
                                className="recurring-date"
                                placeholder="e.g 10:00"
                                suffixIcon={<img src={clock} alt="" />}
                                use12Hours
                                minuteStep={30}
                                showSecond={false}
                                changeOnBlur={true}
                                style={{
                                  borderRadius: "0.5rem",
                                  border: "1px solid #eceef8",
                                  fontSize: "0.9375rem",
                                  backgroundColor: "#fff",
                                  height: 56,
                                  width: "100%",
                                  color: "#30307d",
                                }}
                                onChange={(e) => {
                                  setSchedules([
                                    {
                                      ...schedules[0],
                                      end_time: e.format("HH:mm"),
                                    },
                                  ]);
                                }}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* // </Form> */}

                  {!!formFields?.schedules?.length && <ScheduleTable />}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="[@media(max-width:699px)]:fixed [@media(max-width:699px)]:bg-white [@media(max-width:699px)]:border-t border-neutral bottom-0 left-0 [@media(max-width:699px)]:p-5 w-full">
          <QalortButton
            className="!py-3 w-full"
            type="primary"
            htmlType="submit"
            testid="cohort_step2"
          >
            Proceed
          </QalortButton>
        </div>
      </Form>

      <NewSessionModal
        visible={visible}
        setVisible={setVisible}
        setNewSchedule={setNewSchedule}
        newSchedule={newSchedule}
        frequency={frequency}
        setSchedules={setSchedules}
      />
    </>
  );
}

export default CreateStep2;
